module.exports = __webpack_public_path__ + "img/image_5.16fb330c.svg";